import api from '../http-common';

const getOptionsData = (signal?: AbortSignal) =>
  api.post('/settings/pop-ups/get-options-data', {}, { signal });

const createLoginPopup = (data) =>
  api.post('/settings/pop-ups/store', data)

const getLoginPopupsList = (signal?: AbortSignal) =>
  api.post('/settings/pop-ups/index', {}, { signal })

const getLoginPopup = (id: string, signal?: AbortSignal) =>
  api.post(`/settings/pop-ups/${id}/edit`, {}, { signal })

const updateLoginPopup = (id, data) =>
  api.post(`/settings/pop-ups/${id}/update`, data)

const showLoginPopup = (id) =>
  api.post(`/settings/pop-ups/${id}/show`)

const deleteLoginPopup = (id) =>
  api.post(`/settings/pop-ups/${id}/delete`)

const getFileUrl = (id, data?) =>
  api.post(`/settings/pop-ups/${id}/get-file-url`, data)

/// Farmer login popups

const getFarmerLoginPopups = () =>
  api.post('/pop-ups/get-data')

const enableLoginPopups = () =>
  api.post('/pop-ups/enable-on-login')

const disableLoginPopups = () =>
  api.post('/pop-ups/disable-on-login')

const getFarmerLoginPopupUrl = (id: string) =>
  api.post(`/pop-ups/${id}/get-file-url`)

export const LoginPopupsService = {
  getOptionsData,
  createLoginPopup,
  getFileUrl,
  getLoginPopup,
  updateLoginPopup,
  showLoginPopup,
  deleteLoginPopup,
  getLoginPopupsList,
  getFarmerLoginPopups,
  getFarmerLoginPopupUrl,
  enableLoginPopups,
  disableLoginPopups
}
